import { FC, memo, useState } from 'react';
import Blocks from '../Blocks/Blocks';
import SiteMenu from '../SiteMenu/SiteMenu';
import MedVoxTasks from './MedVoxTasks/MedVoxTasks';
import blockStyles from '../Blocks/style.module.css';
import RoboTasks from './RoboTasks/RoboTasks';

interface Props {
  selectedKey: string;
  updateData: (key: string) => void;
  // showRoboCall: boolean;
  // showMedVox: boolean;
}

const Tasks: FC<Props> = (props: Props) => {
  return (
    <>
      <Blocks
        topBlock={
          <div className={blockStyles.topBlockRowStart}>
            <SiteMenu title="Журнал заданий" />
          </div>
        }
        mainBlock={<MedVoxTasks showMedVox />}
        // mainBlock={
        //   props.showRoboCall ? (
        //     <RoboTasks showRoboCall={props.showRoboCall} />
        //   ) : (
        //     <MedVoxTasks showMedVox={props.showMedVox} />
        //   )
        // }
      />
    </>
  );
};

export default memo(Tasks);
